import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { useDispatch } from "react-redux";

import { router } from "@/routes";
import useWsConnection from "./hooks/useWsConnection";
import useConfigVersionSync from "./hooks/useConfigVersionSync";
import useSessionRenewal from "./hooks/useSessionRenewal";
import { bootstrapAuth } from "@/redux/reducers/AuthReducer";
import { BrandingProvider } from "@/providers/BrandingProvider";
import AuthService from "@/services/authService";
// DISABLED-FEATURE: browser extension is switched off — see server/app/api/v2/api.py.
// import ExtensionService from "@/services/extensionService";

const App = () => {
  useWsConnection();
  // Keeps permissions / module state fresh without a re-login: WebSocket push
  // for latency, X-Config-Version header comparison for correctness.
  useConfigVersionSync();
  // Renews the access token before it expires, so an open tab that makes no
  // requests still holds a live session — and a live WebSocket.
  useSessionRenewal();
  const dispatch = useDispatch();

  // The theme is painted in main.jsx, before the first render. Re-dispatching
  // it here only repeated the same write a frame later.
  useEffect(() => {
    dispatch(bootstrapAuth());

    // DISABLED-FEATURE: browser extension is switched off — see server/app/api/v2/api.py.
    // // bootstrapAuth (above) and the post-login push (login/index.jsx) each
    // // try to hand the extension a JWT exactly ONCE, at the moment they run —
    // // if bridge.js isn't on the page yet at that exact instant (the common
    // // case: "Connect this site" is something you do AFTER you're already
    // // logged in, not before), the push is skipped and nothing ever retries
    // // it. This listener is the retry: it lives for the whole app session
    // // and fires the push again the moment bridge.js actually announces
    // // itself, however long after boot/login that happens to be.
    // const onExtensionReady = () => {
    //   const jwt = AuthService.getAccessToken();
    //   if (!jwt) return;
    //   ExtensionService.pushJwt(jwt)
    //     .then((res) => {
    //       if (!res || !res.ok) {
    //         console.warn("[TalentFlow ext] ready-triggered JWT push failed:", res);
    //       } else {
    //         console.log("[TalentFlow ext] ready-triggered JWT push OK:", res);
    //       }
    //     })
    //     .catch((err) => console.warn("[TalentFlow ext] ready-triggered push threw:", err));
    // };
    // window.addEventListener("talentflow:extension-ready", onExtensionReady);
    // return () => window.removeEventListener("talentflow:extension-ready", onExtensionReady);
  }, [dispatch]);

  return (
    <BrandingProvider>
      <div className="flex h-screen overflow-hidden">
        <main className="flex-1 overflow-auto bg-background-primary transition-colors duration-300 ease-in-out">
          <RouterProvider router={router} />
        </main>
      </div>
    </BrandingProvider>
  );
};

export default App;
